import type {ApiResponse} from "@/scripts/Common/api";
import {defaultFetch, httpMethod} from "@/scripts/Common/api";
import {getToken} from "@/scripts/Common";

const resetPassword = async (group: 'customer' | 'user' | 'issuer', id: number)
  : Promise<ApiResponse<number>> => await defaultFetch({
  apiName: 'passwordReset',
  options: {
    method: httpMethod.PUT,
    routeParams: {
      group,
      id: id.toString(10)
    }
  },
  bearer: getToken()
});

export {
  resetPassword
}

